import { type TrackerMessage, TrackerMessagesSchema } from '@racemap/sdk/schema/trackers';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import type { ObjectId } from '@racemap/utilities/types/utils';
import useSWR from 'swr';

const apiClient = RacemapAPIClient.fromWindowLocation();

export const TRACKER_MESSAGES_SWR_KEY = 'TRACKER_MESSAGES';

export function useTrackerMessages(trackerId: ObjectId | string | null | undefined): {
  messages: Array<TrackerMessage>;
  isLoading: boolean;
  error: Error | undefined;
} {
  const id = trackerId?.toString();
  const { data, isLoading, error } = useSWR(
    id != null ? ['GET', TRACKER_MESSAGES_SWR_KEY, id] : null,
    async ([, , trackerId]) => {
      const raw = await apiClient.listTrackerMessages({ trackerId });
      return TrackerMessagesSchema.parse(raw);
    },
    {
      revalidateIfStale: false,
    },
  );

  return { messages: data ?? [], isLoading, error };
}
